import { render, staticRenderFns } from "./AbutmentList.vue?vue&type=template&id=6eca7400&scoped=true"
import script from "./AbutmentList.vue?vue&type=script&lang=js"
export * from "./AbutmentList.vue?vue&type=script&lang=js"
import style0 from "./AbutmentList.vue?vue&type=style&index=0&id=6eca7400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca7400",
  null
  
)

export default component.exports